import type React from 'react';
import { ChatBubble, InteractiveChatBubble } from '../..';

export type ChatBubbleWithLinkFeatureToggleProps = {
  children: React.ReactNode;
  senderName?: string;
  shouldIncludeGutter?: boolean;
  variant: 'autoResponse' | 'messageOwner' | 'default';
  enableClickableLinks?: boolean;
  onImpact?: boolean;
};

/**
 * ChatBubbleWithLinkFeatureToggle - Support feature flag for ChatBubble with clickable links
 *
 * This component allows satellite-rachel-web and satellite-landlord-web to
 * safely roll out clickable link functionality via feature flags while
 * maintaining the ability to fallback to the original ChatBubble behavior.
 */
export default function ChatBubbleWithLinkFeatureToggle({
  children,
  senderName,
  shouldIncludeGutter = false,
  variant,
  enableClickableLinks = false,
  onImpact,
}: ChatBubbleWithLinkFeatureToggleProps) {
  if (enableClickableLinks) {
    return (
      <InteractiveChatBubble
        senderName={senderName}
        shouldIncludeGutter={shouldIncludeGutter}
        variant={variant}
        onImpact={onImpact}
      >
        {children}
      </InteractiveChatBubble>
    );
  }

  return (
    <ChatBubble senderName={senderName} shouldIncludeGutter={shouldIncludeGutter} variant={variant}>
      {children}
    </ChatBubble>
  );
}
